export class Direccion {
    cliente: number;
    alias: string;
    pais: number;
    estado: number;
    ciudad: number;
    colonia: string;
    calle: string;
    codigo: string;
    numero: string;

    LOCATION:number;
    LOCATION_ID:number;
    SUBURB:number;
    SUBURB_ID:number;
    POSTAL_CODE:number;
    POSTAL_CODE_ID:number;
}


// WEBPACK FOOTER //
// ./src/app/models/direccion.ts